<template>
  <div class="c-bg--gray--pc c-common-footer-fixed">
    <div class="c-common-footer-fixed__inner">
      <theHeader />
      <div class="c-common-inner">
        <TheTemplateJ
          :heading="thanksPointName2 + 'メッセージ'"
          :indicated-item="['button']"
        >
          <template #contents>
            <div class="p-the-page-j02">
              <div class="p-the-page-j02__body">
                <i class="p-the-page-j02__body__icon">
                  <IconBalloons />
                </i>
                <div class="p-the-page-j02__body__text">
                  <p>
                    <SmallText :size="14"
                      >仲間に{{ thanksPointName1 }}を贈ってみよう！</SmallText
                    >
                  </p>
                </div>
              </div>
            </div>
          </template>
        </TheTemplateJ>
      </div>
    </div>
    <TheFooter />
  </div>
</template>

<script lang="ts">
import TheHeader from "@/common/components/organisms/TheHeader.vue";
import TheFooter from "@/common/components/organisms/TheFooter.vue";

import SmallText from "@/common/components/atoms/SmallText.vue";
import IconBalloons from "@/common/components/icons/IconBalloons.vue";

import TheTemplateJ from "@/general/components/templates/TheTemplateJ.vue";
import { Options, Vue } from "vue-class-component";
import commons from "@/common/store/modules/commons";
import { getThanksPointName } from "@/common/assets/js/utils/pointName";
import sitemap from "@/general/mixins/const/custom/sitemap";
import CONST_DATA from "@/general/mixins/const/constData";
import AuthStorage from "@/general/utils/auth";

@Options({
  components: {
    TheHeader,
    TheFooter,
    SmallText,
    IconBalloons,
    TheTemplateJ
  }
})
export default class ThanksPointNoGifts extends Vue {
  breadcrumb: any = [
    {
      text: "",
      url: sitemap.TOP_PAGE,
      pageType: "home"
    },
    {
      text: "サンクスメッセージ",
      url: "",
      pageType: "lower"
    }
  ];

  get thanksPointName1() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME1);
  }

  get thanksPointName2() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME2);
  }

  async created() {
    await commons.setOrgPageSpecificDataFromLocalStorage();
    this.breadcrumb[1].text = this.thanksPointName2 + "メッセージ";
    await commons.setbreadcrumb(this.breadcrumb);
  }

  mounted() {
    AuthStorage.checkLogin();
  }
}
</script>

<style lang="scss" scoped>
.p-the-page-j02 {
  @include pc {
    width: rem(567);
    padding-top: rem(48);
  }
  @include sp {
    width: rem(277);
    padding-top: rem(32);
  }
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  &__body {
    &__icon {
    }

    &__text {
      margin-top: rem(48);
    }
  }
}
</style>
